"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function loadDataFromURL(url) {
  var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "text";
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return fetch(url).then(function (response) {
    if (response.ok && response.status == 200) {
      if (contentType == "text") {
        return response.text();
      }

      if (contentType == "json") {
        return response.json();
      }

      if (contentType == "arraybuffer") {
        return response.arrayBuffer();
      }

      if (contentType == "blob") {
        return response.blob();
      }

      return response.text();
    } else {
      throw new Error("failed to fetch url");
    }
  });
}

exports.loadDataFromURL = loadDataFromURL;